import { render, staticRenderFns } from "./incidencias.vue?vue&type=template&id=66bf6988&scoped=true"
import script from "./incidencias.vue?vue&type=script&lang=js"
export * from "./incidencias.vue?vue&type=script&lang=js"
import style0 from "./incidencias.vue?vue&type=style&index=0&id=66bf6988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bf6988",
  null
  
)

export default component.exports